import React from 'react';
import AdminPortfolioForm from '../components/admin/portfolio/AdminPortfolioForm';

const AdminPortfolioFormPage = () => {
    return (
        <AdminPortfolioForm />
    );
};

export default AdminPortfolioFormPage;